//#region Styles
import {
    ContainerParts, Part 
} from "components/styles";
//#endregion
//#region Components
import UploadFileBlock from "../../components/UploadFileBlock/UploadFileBlock";

//#endregion

const Step1 = ({
    form,
    errors
}) => {
    //#region Functions
    const changeFieldFileData = value => {
        form.change("fileData", value, false);
    }
    //#endregion
    return (
        <ContainerParts>
            <Part>
                <UploadFileBlock 
                    title="Sigue los pasos"
                    description={
                    <p>
                        Selecciona un archivo con la información establecida en formato <strong>CSV</strong> que contenga las columnas del formato modelo:
                    </p>}
                    changeForm={changeFieldFileData}
                    form={form.value}
                    errors={errors}
                />
            </Part>
        </ContainerParts>
    );
}

export default Step1;